import { useQuery } from '@tanstack/react-query';

import { QuestionnairesApi } from 'api/QuestionnairesApi';
import { CRB_QUESTIONNAIRE_RESULT_KEY } from 'tanstack-hooks/keys';

export function useCrbQuestionnaireResult(crbId = '', questionnaireId = '', resultId = '') {
  const questionnairesApi = new QuestionnairesApi();

  const { data: questionnaireResult, isLoading: isLoadingCrbQuestionnaireResult } = useQuery({
    enabled: !!crbId.length && !!questionnaireId.length && !!resultId.length,
    queryKey: [CRB_QUESTIONNAIRE_RESULT_KEY, crbId, questionnaireId, resultId],
    queryFn: () => questionnairesApi.getCRBQuestionnaireResponse(crbId, questionnaireId, resultId)
  });

  return { questionnaireResult, isLoadingCrbQuestionnaireResult };
}
